import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=0d2da83d&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=0d2da83d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2da83d",
  null
  
)

export default component.exports